import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { Group } from '../types/entities/Group';
import { Activity } from '../types/entities/Activity';
import { NumberField } from '../components/Table/fields/NumberField';
import { SelectField } from '../components/Table/fields/SelectField';
import { TextField } from '../components/Table/fields/TextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectUserField } from '../components/Table/fields/SPSelectUserField';
import { userByRole } from './userByRole';

export const guideReservation = (
  forGroupId?: Group['id'],
  forActivityId?: Activity['id']
): SchemaWithClient<any> => {
  return {
    name: 'Guide Reservations',
    pluralName: 'Guide Reservations',
    tabs: [
      {
        id: 1,
        label: 'General',
        name: 'general',
      },
    ],
    columns: {
      name: {
        name: 'Name',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        hide: true,
      },
      guide: {
        name: 'Guide',
        fieldRenderer: SelectField.tableAdapter(userByRole('5')),
        slidePaneFieldRenderer: SPSelectUserField.tableAdapter(userByRole('5')),
        url: userByRole('5').client.getAllPath,
        tempSchema: userByRole('5'),
        switchboard: true,
      },
      guide_wage: {
        name: 'Guide Wage',
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPNumberField,
        fieldType: 'number',
      },
      guide_wage_currency: {
        name: 'Guide Wage Currency',
        fieldRenderer: SelectField.tableAdapter(enumItems.currency),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
        switchboard: true,
        tempSchema: enumItems.currency,
        url: enumItems.currency.client.getAllPath,
      },
      id: {
        name: 'ID',
        required: true,
        fieldRenderer: NumberField,
        fieldType: 'number',
        readOnly: true,
      },
    },
    client: new Client(
      '/guide-reservations',
      forGroupId !== undefined
        ? `/groups/${forGroupId}/guide-reservations`
        : undefined
    ),
  };
};
